import axiosInstance from "../utils/axios";

export const getByUserId = async (id, query, setData) => {
    try {
        await axiosInstance.get(`/my-book/getByUserId/${id}?${query}`)
            .then((res) => {
                setData(res?.data);
            })
    } catch (error) {
        console.log(error);
    }
}

export const getBySlug = async (slug, query, setData, message) => {
    try {
        await axiosInstance.get(`/my-book/getBySlug/${slug}?${query}`)
            .then((res) => {
                setData(res?.data);
                message.info(String(res?.data?.message));
            })
    } catch (error) {
        console.log(error);
    }
}

export const getListCategoryChild = async (setData) => {
    try {
        await axiosInstance.get(`/my-book/getListCategoryChild`)
            .then((res) => {
                setData(res?.data);
            })
    } catch (error) {
        console.log(error);
    }
}
export const getDocxReaderBuffer = async (slug) => {
    const response =
        await axiosInstance.get(
            `/my-book/pdf/${encodeURIComponent(slug)}`,
            {
                responseType: "arraybuffer"
            }
        );

    return {
        data: response.data,
        contentType:
            response.headers?.["content-type"] ||
            ""
    };
};


export const getReaderMeta = async (
    slug,
    userId
) => {
    const response =
        await axiosInstance.get(
            `/my-book/reader-meta/${encodeURIComponent(slug)}`,
            {
                params: {
                    user_id:
                        userId
                }
            }
        );

    return response.data;
};

export const getReaderFolder = async (
    slug,
    url
) => {
    const response =
        await axiosInstance.get(
            `/my-book/reader-folder/${encodeURIComponent(slug)}`,
            {
                params: {
                    url
                }
            }
        );

    return response.data;
};



export const getReaderChildFolder = async (
    slug,
    folderId,
    parentId
) => {
    return axiosInstance.get(
        `/my-book/reader-folder/${encodeURIComponent(slug)}` +
        `?url=${encodeURIComponent(
            "https://drive.google.com/drive/folders/" +
            folderId
        )}` +
        `&parent_id=${encodeURIComponent(parentId)}`
    );
};

export const getReaderFolderFileBlob = async (
    url
) => {
    const response =
        await axiosInstance.get(
            url,
            {
                responseType:
                    "blob"
            }
        );

    return response.data;
};
